<!--スケジュール-->
<!--tab1シフト申請-->
<template>
  <div style="border: 0px solid red; height:100%" class="s0001tab1Class">
    <!-- 年月 -->
    <el-row type="flex" align="bottom">
      <el-col :span="9" align="middle">
        <span>{{selectedMonthStr}}</span>
      </el-col>
      <el-col :span="14" align="right" style="font-size: 0">
        <el-button style="background-color: #f7fbfc;margin-left:0px;border-radius:0px" size="small" @click.native="preMonthClick">{{$t('MODULE.S0001_LBL_PREMONTH')}}</el-button>
        <el-button style="background-color: #f7fbfc;margin-left:0px;border-radius:0px" size="small" @click.native="todayClick">{{$t('MODULE.S0001_LBL_TODAY')}}</el-button>
        <el-button style="background-color: #f7fbfc;margin-left:0px;border-radius:0px" size="small" @click.native="nextMonthClick">{{$t('MODULE.S0001_LBL_NEXTMONTH')}}</el-button>
      </el-col>
    </el-row>
    <!-- リスト表示 -->
    <el-row style="margin-top: 6px;">
      <el-col :span="8" align="left">
        <span v-if="shiftLockFlg_out_object=='1'" style="font-size:10px;color:red;font-weight:bold">{{$t('MODULE.S0001_LBL_LOCKED_OUT_OBJECT')}}</span>
        <span v-else-if="shiftLockFlg_done=='1'" style="font-size:10px;color:red;font-weight:bold">{{$t('MODULE.S0001_LBL_LOCKED_DONE')}}</span>
        <span v-else>&nbsp;&nbsp;&nbsp;</span>
      </el-col>
      <el-col :span="16" align="right">
        <el-radio-group v-model="calenderMode_radio" @change="radioChange">
          <el-radio label="1">{{$t('MODULE.S0001_LBL_RADIO_CALENDER')}}</el-radio>
          <el-radio label="2">{{$t('MODULE.S0001_LBL_RADIO_LIST')}}</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
    <!-- 注意事項 -->
    <el-row style="margin-top: 6px;">
        <el-card  align="left" shadow="never" style="border:0px;margin-top: 4px;background-color: #ffffff;font-size:13px" :body-style="{ padding:'4px 2px 4px 2px' }">
          <span>{{$t('MODULE.S0001_LBL_TAB1_LONG_ATTENTION')}}</span>
        </el-card>
    </el-row>
    <!----------------------------------------カレンダー表示  calenderMode==1------------------------------>
    <el-row v-show="calenderMode==1" class="calenderMode1-calendar" style="text-align:center;margin-top: 2px;">
      <div style="padding: 0px 0px 0px 0px; width: 100%;height: 100%;">
        <el-calendar :firstDayOfWeek="7" ref="elCalendar" v-model="currentDate">
          <template slot="dateCell" slot-scope="{date, data}">
            <div slot="reference" class="el-calendar-day" @touchmove="touchMove()" @touchstart="touchStart(data)" @touchend="touchEnd(data)" :class="calendarCellCss(data)">
              <div v-html="data.day.split('-')[2]"></div>
              <div v-html="calendarCellcharacters(data)"></div>
            </div>
          </template>
        </el-calendar>
      </div>
      <!--カード-->
      <el-card v-show="selectedDay" align="left" shadow="always" style="margin-top: 4px;background-color: #23b2e8;color:#ffffff" :body-style="{ padding:'4px 2px 4px 2px' }">
        <span>・{{toStrToDay2(this.selectedDay)}}</span>
      </el-card>
      <el-card v-show="calenderMode==1&&selectedDay!==''" shadow="always" style="margin-top: 0px;background-color: #f7fbfc;" :body-style="{ padding:'4px 2px 4px 2px' }">
        <!-- 出勤可能時間帯： -->
        <el-row>
          <el-col :span="10" align="left">
            <td>{{$t('MODULE.S0001_TITTLE_ATTENTIMELONG')}}</td>
          </el-col>
          <el-col :span="6" align="left">
            <el-input :class="!isEditMode||readonlyTimeSet||passedDateFlg?'card-css-input-readonly':'card-css-input'" size="small" @blur="cal1_inputBlur($event,'timeFrom')" ref="timeFrom" v-model="timeFrom" :readonly="shiftLockFlg==='1'||!isEditMode||readonlyTimeSet||passedDateFlg"  @input.native="timeInputCheck($event)" pattern="\d*"></el-input>
          </el-col>
          <el-col :span="2" align="center">
            <span>~</span>
          </el-col>
          <el-col :span="6" align="right">
            <el-input :class="!isEditMode||readonlyTimeSet||passedDateFlg?'card-css-input-readonly':'card-css-input'" size="small" @blur="cal1_inputBlur($event,'timeTo')" ref="timeTo" v-model="timeTo" :readonly="shiftLockFlg==='1'||!isEditMode||readonlyTimeSet||passedDateFlg"  @input.native="timeInputCheck($event)" pattern="\d*"></el-input>
          </el-col>
        </el-row>
        <!-- 備考： -->
        <el-row style="margin-top: 3px;">
          <el-col :span="4" align="left">
            <td>{{$t('MODULE.S0001_TITTLE_READY')}}</td>
          </el-col>
          <el-col :span="20" align="center">
            <el-row>
              <el-input :class="!isEditMode||passedDateFlg?'card-css-input-readonly':'card-css-input'" maxlength='200' type="textarea" :rows="2" size="small" ref="remark" @blur="cal1_inputBlur($event,'remark')" v-model="remark" :readonly="shiftLockFlg==='1'||!isEditMode||passedDateFlg"></el-input>
            </el-row>
          </el-col>
        </el-row>
      </el-card>
    </el-row>
    <!--------------------リスト表示 --calenderMode==2------------------------------------------->
    <el-row ref="calenderMode2calendar" v-show="calenderMode==2" class="calenderMode2-calendar" style="text-align:center;margin-top: 2px;">
      <el-table :data="calenderMode2DateList" border stripe style="width: 100%;" :row-style="calenderMode2calendarCss">
        <!-- 日付 -->
        <el-table-column prop="jobDate" :label="$t('MODULE.S0001_LBL_JOBDATE')" width="60" align="center">
          <template slot-scope="scope">
            <span>{{toStrToDay(scope.row.jobDate)}}</span>
          </template>
        </el-table-column>
        <!-- 区分 -->
        <el-table-column prop="attendanceDiv" :label="$t('MODULE.S0001_LBL_ATTENDANCEDIV')" width="60">
          <template slot-scope="scope">
            <el-select v-if="shiftLockFlg==='0'&&scope.row.jobDate>strToDay" v-model="scope.row.attendanceDiv" @change="cal2_attendanceDivChangeEvent($event,'attendanceDiv',scope.row.jobDate,scope.$index,scope.row.attendanceDiv)">
              <el-option :label="icon_o" value="0">{{icon_o}}</el-option>
              <el-option :label="icon_x" value="2">{{icon_x}}</el-option>
            </el-select>
            <span  v-else>
              <span v-if="scope.row.attendanceDiv=='0'">{{icon_o}}</span>
              <span v-if="scope.row.attendanceDiv=='2'">{{icon_x}}</span>            
            </span>
          </template>
        </el-table-column>
        <!-- 時間帯 -->
        <el-table-column :label="$t('MODULE.S0001_LBL_TIMELONG')" prop="timeLong" width="140">
          <template slot-scope="scope">
            <el-input style="width:40%" v-if="shiftLockFlg==='0'&&scope.row.jobDate>strToDay" v-model="scope.row.timeFrom" @input.native="timeInputCheck($event)" @blur="cal2_inputBlur($event,'timeFrom',scope.row.jobDate,scope.$index)" :disabled="scope.row.attendanceDiv==='2'" pattern="\d*"></el-input>
            <span v-else>{{scope.row.timeFrom}}</span>
            <span>~</span>
            <el-input style="width:40%" v-if="shiftLockFlg==='0'&&scope.row.jobDate>strToDay" v-model="scope.row.timeTo" @input.native="timeInputCheck($event)" @blur="cal2_inputBlur($event,'timeTo',scope.row.jobDate,scope.$index)" :disabled="scope.row.attendanceDiv==='2'" pattern="\d*"></el-input>
            <span v-else>{{scope.row.timeTo}}</span>
          </template>
        </el-table-column>
        <!-- 備考 -->
        <el-table-column :label="$t('MODULE.S0001_LBL_READY')" prop="remark">
          <template slot-scope="scope">
            <el-input v-if="shiftLockFlg==='0'&&scope.row.jobDate>strToDay" @blur="cal2_inputBlur($event,'remark',scope.row.jobDate,scope.$index)" v-model="scope.row.remark"></el-input>
            <span v-else>{{scope.row.remark}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!------------------ボタン------------------>
    <el-row style="margin-top: 8px;">
      <el-col :span="24" style="margin-left:15px;" align="center">
        <el-button class="css-btn css-button" type="primary" style="margin-top: 8px;font-size: 10pt;width:20%" v-show="!passedDateFlg&&shiftLockFlg==='0'&&((this.calenderMode === '2')||isEditMode)" @click.native="applyClick" @click="handleClick">{{$t('COMMON.BTN_APPLY')}}</el-button>
        <el-button class="css-btn css-button" type="primary" style="margin-top: 8px;font-size: 10pt;width:30%" v-show="isEditMode&&(this.calenderMode === '1')" @click.native="strDoSelectClean">{{$t('COMMON.BTN_CANCEL')}}</el-button>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import * as amsApi from "../api/s_0001"
import locale from "element-ui/lib/locale/lang/ja"
let url = require('@/../config/sysConfig')
import utilsApi from '../../common/utils'
export default {
  // props: ['tabsIndex'],
  // name: "Map",
  data() {
    return {
      currentDate:'',
      calenderDateList: [],//calender1表示用list
      calenderMode2DateList: [],//calender2表示用list
      selectedMonth: '',//当前月（字符串格式）
      selectedDay: '',//当前点击的日期（字符串格式）
      updateList: [],//编辑模式下的临时list(保存用)
      calenderMode: '1',//1：calender表示，2：list表示  全局用
      calenderMode_radio: '1',//1：calender表示，2：list表示  radio专用
      isEditMode: false,//false：非选择模式,true:选择模式
      readonlyTimeSet: false,//时间模块是否只读
      touchmoveFlag: false,
      firstEditClickFlg: true,//判断是否是编辑模式下第一次点击按钮
      hasEditedDateFlg: false,//是否有已经编辑数据flg
      blurErrorFlg: false,
      // isCurrentMonth: true,
      timeFrom: '',
      timeTo: '',
      remark: '',
      tabsIndex: '',
      login_officeCd: '',//登陆者所属officecd
      login_userCd: '',//登陆者cd
      icon_o: '〇',
      icon_x: '✖',
      shiftLockFlg: '0',//本月lock情况:1=lock
      shiftLockFlg_done: '0',//本月lock情况表示用（シフト申請対象外）
      shiftLockFlg_out_object: '0',//本月lock情况表示用（シフトロック済）
      weekStr: [],//一周的文言
      strToDay: '',//今日日期（yyyy/mm/dd）
      passedDateFlg: false,//编辑模式中，过去日判定用flg
      longPress:'false'//触发长按标志位
    };
  },

  mounted() {
    //カレンダーのセルセット
    let calendarThead = document.querySelector(
      ".s0001tab1Class .el-calendar-table thead"
    );
    calendarThead.childNodes[0].style.color = "red"
    calendarThead.childNodes[6].style.color = "blue"
    this.weekStr[0] = this.$t('MODULE.S0001_LBL_CALENDAR_SUN')
    this.weekStr[1] = this.$t('MODULE.S0001_LBL_CALENDAR_MON')
    this.weekStr[2] = this.$t('MODULE.S0001_LBL_CALENDAR_TUE')
    this.weekStr[3] = this.$t('MODULE.S0001_LBL_CALENDAR_WED')
    this.weekStr[4] = this.$t('MODULE.S0001_LBL_CALENDAR_THU')
    this.weekStr[5] = this.$t('MODULE.S0001_LBL_CALENDAR_FRI')
    this.weekStr[6] = this.$t('MODULE.S0001_LBL_CALENDAR_SAT')
    //周tittle设置
    for (var i = 0; i < 7; i++) {
      calendarThead.childNodes[i].innerHTML = this.weekStr[i]
    }

    let calendarTbody = document.querySelector(
      ".s0001tab1Class .el-calendar-table tbody"
    );
    var calendarTbodyChildren = calendarTbody.children;
    var calendarTbodyChildrenChildren;
    for (var i = 0; i < calendarTbodyChildren.length; i++) {
      calendarTbodyChildrenChildren = calendarTbody.children[i]
      if (i % 2 != 0) {
        //隔行变色处理
        calendarTbodyChildrenChildren.style.background = "#f7fbfc"
      }
    }
  },
  created: function () {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.login_officeCd = userInfo.officeCd
    this.login_userCd = userInfo.userCd
    this.selectedMonth = this.dateFormart(new Date(), 'yyyymm')
    this.strToDay = this.dateFormart(new Date(), 'yyyy/mm/dd')
    this.query()
  },
  methods: {
    //日期字符串转化为 年月日（星期）
    toStrToDay2(thisDay) {
      var theDate = new Date(thisDay)
      var myddy = theDate.getDay()
      return thisDay + '(' + this.weekStr[myddy] + ')'

    },
    //获得tabsindex
    getTabsIndex(val) {
      this.tabsIndex = val
    },
    //calendar2下拉列表改变事件
    cal2_attendanceDivChangeEvent(e, item, jobDate, ItemIndex,targetVal) {
      //updateList保存
      this.saveupdateList(item, targetVal, jobDate)
      if (this.calenderMode2DateList[ItemIndex].attendanceDiv === '2') {
        this.calenderMode2DateList[ItemIndex].timeFrom = ''
        this.calenderMode2DateList[ItemIndex].timeTo = ''
      }
    },
    //calendar1时间入力失去焦点事件
    cal1_inputBlur(e, item) {
      if (this.isEditMode == false) return
      var retValue = ''
      if (item == 'remark') {
        retValue = e.target.value
      } else {
        if (e.target.value !== '') {
          retValue = utilsApi.timeFormatter(e.target.value)
        } else {
          retValue = ''
        }
        this[item] = retValue
      }
      //updateList保存
      this.saveupdateList(item, retValue, this.selectedDay)
    },
    //calendar2时间入力失去焦点事件
    cal2_inputBlur(e, item, jobDate, ItemIndex) {

      var retValue = ''
      if (item == 'remark') {
        retValue = e.target.value
        this.calenderMode2DateList[ItemIndex][item] = retValue
      } else {
        if (e.target.value !== '') {
          retValue = utilsApi.timeFormatter(e.target.value)
        } else {
          retValue = ''
        }
        this.calenderMode2DateList[ItemIndex][item] = retValue
      }
      //updateList保存
      this.saveupdateList(item, retValue, jobDate)
      return retValue
    },
    // 时间入力check
    timeInputCheck(e) {
      if (e.target.value === '') return
      var reg = /^\d*(\:?\d{0,2})/g
      var matchResult = e.target.value.match(reg)
      if (matchResult === null) {
        e.target.value = null
      } else {
        e.target.value = matchResult[0]
      }
    },
    //input获取焦点时自动去掉','和':'
    focusInput(item, itemName) {
      item = item.toString().replace(/:|,/g, "");
      if (itemName === 'timeFrom') {
        this.timeFrom = item;
      }
      if (itemName === 'timeTo') {
        this.timeTo = item;
      }
    },
    //calender模式切换事件
    radioChange(val) {
      if (val === '2') {
        if (this.isEditMode == true) {
          if (this.updateList.length > 0) {
            this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
              confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
              cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
              center: true
            }).then(() => {
              this.updateList = undefined;
              this.updateList = new Array();
              this.isEditMode = false
              this.firstEditClickFlg = true
              this.calenderMode2DateList = JSON.parse(JSON.stringify(this.calenderDateList));
              this.calenderMode = '2'
            }).catch(() => {
              this.calenderMode = '1'
              this.calenderMode_radio = '1'
            })
          } else {
            this.updateList = undefined;
            this.updateList = new Array();
            this.isEditMode = false
            this.firstEditClickFlg = true
            this.calenderMode2DateList = JSON.parse(JSON.stringify(this.calenderDateList));
            this.calenderMode = '2'
          }
        } else {
          this.isEditMode = false
          this.firstEditClickFlg = true
          this.calenderMode2DateList = JSON.parse(JSON.stringify(this.calenderDateList));
          this.calenderMode = '2'
        }
      } else {
        if (this.updateList.length > 0) {
          this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: true
          }).then(() => {
            //this.selectedDay=''
            this.updateList = undefined;
            this.updateList = new Array();
            this.isEditMode = false
            this.firstEditClickFlg = true
            this.calenderMode2DateList = undefined;
            this.calenderMode = '1'
          }).catch(() => {
            this.calenderMode = '2'
            this.calenderMode_radio = '2'
          })
        } else {
          //this.selectedDay=''
          this.isEditMode = false
          this.firstEditClickFlg = true
          this.calenderMode = '1'
        }
      }
    },

    //日期字符串转化为 日（星期）
    toStrToDay(thisDay) {
      var theDate = new Date(thisDay)
      var myddy = theDate.getDay()
      return thisDay.substring(8, 10) + '(' + this.weekStr[myddy] + ')'

    },
    // 検索
    query() {
      var Params = {
        "salesOfficeCd": this.login_officeCd,
        "userId": this.login_userCd,
        "month": this.selectedMonth,
        "page": 1,
        "size": 100
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      })
      setTimeout(() => {
        loading.close()
      }, 2000)
      // 検索処理
      amsApi.s0001Tab1_search(Params).then(res => {
        // 戻るリスト
        //初始化前清空
        this.calenderDateList = undefined;
        this.calenderDateList = new Array();
        if (res.code === 300) {
          //this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          this.shiftLockFlg = '1'
          this.shiftLockFlg_out_object = '1'
          this.shiftLockFlg_done = '0'
          loading.close()
          return
        } else {
          this.shiftLockFlg = res.items.shiftSet[0].shiftLockFlg
          if (this.shiftLockFlg === '1') {
            this.shiftLockFlg_out_object = '0'
            this.shiftLockFlg_done = '1'
          } else {
            this.shiftLockFlg_out_object = '0'
            this.shiftLockFlg_done = '0'
          }
          //更新基本list
          this.calenderDateList = JSON.parse(JSON.stringify(res.items.shiftSet[0].dateItems));
          //△-> ○
          this.calenderDateList.forEach(item => {
            if (item.attendanceDiv === '1') {
              item.attendanceDiv = '0'
            }
          })
          //更新cal2表示用list
          if (this.calenderMode === '2') {
            this.calenderMode2DateList = JSON.parse(JSON.stringify(this.calenderDateList));
          }
        }
        loading.close()
      })
    },
    //日期转为字符串formartType='yyyymm'或'yyyy/mm/dd'或yyyy-mm-dd，
    dateFormart(val, formartType) {
      var y = val.getFullYear();
      var M = val.getMonth() + 1;
      var d = val.getDate();
      if (formartType == 'yyyy-mm-dd') return y + '-' + (M < 10 ? ('0' + M) : M) + '-' + (d < 10 ? ('0' + d) : d);
      if (formartType == 'yyyy/mm/dd') return y + '/' + (M < 10 ? ('0' + M) : M) + '/' + (d < 10 ? ('0' + d) : d);
      if (formartType == 'yyyymm') return y + '' + (M < 10 ? ('0' + M) : M);

    },

    // TABLE单元格样式
    calenderMode2calendarCss({ row, colum, rowIndex, columnIndex }) {
      return 'text-align:center;'
    },

    //前月翌月今日综合处理
    monthChange(val) {

      //编辑模式或者cal2的场合，若更新list里有值，询问是否变更
      if ((this.isEditMode == true || this.calenderMode === '2') && this.updateList.length > 0) {
        this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(() => {
          this.updateList = undefined;
          this.updateList = new Array();
          this.isEditMode = false
          this.firstEditClickFlg = true
          var getEl = this.$refs.elCalendar.$children[0].$children[val]
          //触发调转事件
          getEl.$el.click();
          this.$nextTick(() => {
            let calendarTitle = document.querySelector(
              ".s0001tab1Class .el-calendar__header .el-calendar__title"
            );
            var monthStr = calendarTitle.innerHTML
            if (monthStr.substring(15, 16) === '0' || monthStr.substring(15, 16) === '1' || monthStr.substring(15, 16) === '2') {
              this.selectedMonth = monthStr.substring(7, 11) + monthStr.substring(14, 16)
            } else {
              this.selectedMonth = monthStr.substring(7, 11) + '0' + monthStr.substring(14, 15)
            }
            //刷新数据
            this.query()
            if (document.querySelector(".is-selected") !== null) {
              document.querySelector(".is-selected").classList.remove('is-selected');
            }
            this.selectedDay = ''

          })
        }).catch(() => {
          // いいえ
        })
      } else {
        this.updateList = undefined;
        this.updateList = new Array();
        this.isEditMode = false
        this.firstEditClickFlg = true
        var getEl = this.$refs.elCalendar.$children[0].$children[val]
        //触发调转事件
        getEl.$el.click();
        this.$nextTick(() => {
          let calendarTitle = document.querySelector(
            ".s0001tab1Class .el-calendar__header .el-calendar__title"
          );
          var monthStr = calendarTitle.innerHTML
          if (monthStr.substring(15, 16) === '0' || monthStr.substring(15, 16) === '1' || monthStr.substring(15, 16) === '2') {
            this.selectedMonth = monthStr.substring(7, 11) + monthStr.substring(14, 16)
          } else {
            this.selectedMonth = monthStr.substring(7, 11) + '0' + monthStr.substring(14, 15)
          }
          //刷新数据
          this.query()
          if (document.querySelector(".is-selected") !== null) {
            document.querySelector(".is-selected").classList.remove('is-selected');
          }
          this.selectedDay = ''

        })
      }
    },
    //前月
    preMonthClick() {
      this.monthChange(0)
    },
    //今日
    todayClick() {
      this.monthChange(1)
    },
    //翌月
    nextMonthClick() {
      this.monthChange(2)
    },
    //出勤区分状态反向处理
    attendanceDivChangeStatus(attendanceDiv) {
      var ret = ''
      if (attendanceDiv === '0') {
        ret = '2';
      } else if (attendanceDiv === '') {
        ret = '0';
      } else {
        ret = '0';
      }
      return ret
    },
    //根据不同区分改变相应的值，并保存在updateList里
    //参数：modify_type修改项目种别，targetVal修改后的值，selectedDay日期
    saveupdateList(modify_type, targetVal, selectedDay) {
      var changeFgl = false
      var thisDayIndex = this.updateList.findIndex(item => item.jobDate === selectedDay)
      //updateList里不存在的场合，先拷贝原始数据list，再将变更信息添加到updateList里
      if (thisDayIndex === -1) {
        var Index = this.calenderDateList.findIndex(item => item.jobDate === selectedDay)
        var tempObj = JSON.parse(JSON.stringify(this.calenderDateList[Index]));
        if (modify_type === 'attendanceDiv') {
          if(targetVal===-1){//-1的场合，直接取反状态
            changeFgl = true
            tempObj.attendanceDiv = this.attendanceDivChangeStatus(tempObj.attendanceDiv)
          }else{//-1以外的场合，正常修改新值
            if (tempObj.attendanceDiv !== targetVal) {
              tempObj.attendanceDiv = targetVal
              changeFgl = true
            }
          }         
          //x的场合时间清空
          if (tempObj.attendanceDiv === '2') {
            tempObj.timeFrom = ''
            tempObj.timeTo = ''
          }
        } else if (modify_type === 'timeFrom') {
          if (tempObj.timeFrom !== targetVal) {
            tempObj.timeFrom = targetVal
            changeFgl = true
          }
        } else if (modify_type === 'timeTo') {
          if (tempObj.timeTo !== targetVal) {
            tempObj.timeTo = targetVal
            changeFgl = true
          }
        } else if (modify_type === 'remark') {
          if (tempObj.remark !== targetVal) {
            tempObj.remark = targetVal
            changeFgl = true
          }
        }
        if (changeFgl) {
          this.updateList.splice(0, 0, tempObj)
        }
      }
      //updateList里存在的场合，直接将变更信息更新updateList里
      else {
        var tempObj = JSON.parse(JSON.stringify(this.updateList[thisDayIndex]));
        if (modify_type === 'attendanceDiv') {
          tempObj.attendanceDiv = this.attendanceDivChangeStatus(tempObj.attendanceDiv)
          //x的场合时间清空
          if (tempObj.attendanceDiv === '2') {
            tempObj.timeFrom = ''
            tempObj.timeTo = ''
          }
        } else if (modify_type === 'timeFrom') {
          tempObj.timeFrom = targetVal
        } else if (modify_type === 'timeTo') {
          tempObj.timeTo = targetVal
        } else if (modify_type === 'remark') {
          tempObj.remark = targetVal
        }
        this.updateList.splice(thisDayIndex, 1, tempObj)
      }
    },
    //日期单元格点击事件。 
    dateCellClick(in_dateDay) {
      var selectedCellDay
      if (in_dateDay !== '') {
        selectedCellDay = in_dateDay.replace(/-/g, '/')
        this.currentDate=new Date(selectedCellDay)
      } else {
        return
      }
      //若为编辑模式，先将上次的日期内容失去焦点并保存（此处理必须在日期变换前）
      if (this.isEditMode) {
        this.$refs.timeFrom.blur()
        this.$refs.timeTo.blur()
        this.$refs.remark.blur()
      }
      //每个日期点击时，第一下只表示，第二下开始编辑
      if (this.selectedDay != selectedCellDay) {
        this.firstEditClickFlg = true
        this.selectedDay = selectedCellDay //日期变换
      }
      //编辑模式处理
      if (this.isEditMode) {
        if (this.selectedDay <= this.strToDay) {
          this.passedDateFlg = true
        } else {
          this.passedDateFlg = false
        }
        if (!this.firstEditClickFlg && !this.passedDateFlg) {
          this.saveupdateList('attendanceDiv', -1, this.selectedDay)//参数为-1表示直接取反
        }
        var Index = this.updateList.findIndex(item => item.jobDate === this.selectedDay)
        if (Index === -1) {
          var Index_cal = this.calenderDateList.findIndex(item => item.jobDate === this.selectedDay)
          if (Index_cal === -1) {
            this.timeFrom = ''
            this.timeTo = ''
            this.remark = ''
          } else {
            this.timeFrom = this.calenderDateList[Index_cal].timeFrom
            this.timeTo = this.calenderDateList[Index_cal].timeTo
            this.remark = this.calenderDateList[Index_cal].remark
            //x的场合,时间设定只读
            if (this.calenderDateList[Index_cal].attendanceDiv === '2') {
              this.readonlyTimeSet = true
            } else {
              this.readonlyTimeSet = false
            }
          }
        } else {
          this.timeFrom = this.updateList[Index].timeFrom
          this.timeTo = this.updateList[Index].timeTo
          this.remark = this.updateList[Index].remark
          //x的场合,时间设定只读
          if (this.updateList[Index].attendanceDiv === '2') {
            this.readonlyTimeSet = true
          } else {
            this.readonlyTimeSet = false
          }
        }
      } else {
        //非编辑模式处理
        var Index = this.calenderDateList.findIndex(item => item.jobDate === this.selectedDay)
        if (Index === -1) {
          this.timeFrom = ''
          this.timeTo = ''
          this.remark = ''
          return
        }
        this.timeFrom = this.calenderDateList[Index].timeFrom
        this.timeTo = this.calenderDateList[Index].timeTo
        this.remark = this.calenderDateList[Index].remark
      }
      //第一次进入编辑模式时改变flg
      if (this.isEditMode == true && this.firstEditClickFlg) {
        this.firstEditClickFlg = false
      }

    },
    //单元格内容表示
    calendarCellcharacters(in_date) {
      var thisDay = in_date.day.replace(/-/g, '/')
      var ret = ''
      ////从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(item => item.jobDate === thisDay)
      if (Index !== -1) {
        var attendanceDiv = this.calenderDateList[Index].attendanceDiv
        if (attendanceDiv && attendanceDiv === '0') {
          ret = this.icon_o
        } else if (attendanceDiv && attendanceDiv === '2') {
          ret = this.icon_x
        } else {
          ret = ''
        }
      } else {
        ret = ''
      }
      //编辑模式的场合，若列表中存在，以编辑模式的列表为主
      if (this.isEditMode) {
        //编辑模式处理
        var editIndex = this.updateList.findIndex(item => item.jobDate === thisDay)
        if (editIndex !== -1) {
          var attendanceDiv = this.updateList[editIndex].attendanceDiv
          if (attendanceDiv && (attendanceDiv === '' || attendanceDiv === '0')) {
            ret = this.icon_o
          } else if (attendanceDiv && attendanceDiv === '2') {
            ret = this.icon_x
          } else {
            ret = ''
          }
        }
      }
      return ret
    },
    //单元格样式
    calendarCellCss(in_date) {
      var thisDay = in_date.day.replace(/-/g, '/')
      var Index = this.calenderDateList.findIndex(item => item.jobDate === thisDay)
      if (Index !== -1) {
        if (this.calenderDateList[Index].jobDate <= this.strToDay) {
          return "cell_status_3"
        } else {
          var crewing = this.calenderDateList[Index].crewing
          var crewingConf = this.calenderDateList[Index].crewingConf
          if (crewing && crewing === '1' && crewingConf && crewingConf === '0') {
            return "cell_status_1"
          } else if (crewingConf && crewingConf === '1') {
            return "cell_status_2"
          } else {
            // return "cell_status_3"
          }
        }
      } else {
        //white
      }
    },
    //申请イベント
    applyClick() {
      //没有更新数据的场合
      if (this.updateList.length <= 0) {
        //月別全入力チェック
        for (var i = 0; i < this.calenderDateList.length; i++) {
          var item = this.calenderDateList[i]
          if (item.attendanceDiv === '' && item.jobDate > this.strToDay) {
            this.$message.error({ message: this.$t('MODULE.S0001_TAB_MSG3'), showClose: true });
            return
          }
        }
        // 保存处理
        this.$confirm(this.$t('COMMON.MSG_SAVE'), { // 保存します。よろしいでしょうか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(() => {
          this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) // 更新成功
          this.isEditMode = false
          this.firstEditClickFlg = true
          this.passedDateFlg = false
        }).catch(() => {
          // いいえ
        })
      } else {
        var param = []
        for (var i = 0; i < this.updateList.length; i++) {
          var item = this.updateList[i]
          //時間帯 46:00以上チェック
          if ((item.timeFrom !== '' && item.timeFrom > '46:00') || (item.timeTo !== '' && item.timeTo > '46:00')) {
            this.$message.error({ message: this.toStrToDay(item.jobDate) + this.$t('COMMON.MSG_TIME_VALIDITY'), showClose: true });
            return
          }
          //時間帯 時間From＜時間Toチェック
          if (item.timeTo !== '' && item.timeFrom !== '' && item.timeFrom >= item.timeTo) {
            this.$message.error({ message: this.toStrToDay(item.jobDate) + this.$t('MODULE.S0001_TAB_MSG1'), showClose: true });
            return
          }

          var tempObj = {
            "month": this.selectedMonth,
            "salesOfficeCd": this.login_officeCd,
            "userId": this.login_userCd,
            "jobDate": item.jobDate,
            "attendanceDiv": (item.attendanceDiv !== '0') ? item.attendanceDiv : (item.timeFrom !== ''||item.timeTo !== '' ? '1' : '0'),
            "timeFrom": item.timeFrom,
            "timeTo": item.timeTo,
            "remark": item.remark,
          }
          param.push(tempObj)
        }
        // var errorFgl=false
        //月別全入力チェック
        for (var i = 0; i < this.calenderDateList.length; i++) {
          var item = this.calenderDateList[i]
          if (item.attendanceDiv === '' && item.jobDate > this.strToDay) {
            var Index = this.updateList.findIndex(edititem => edititem.jobDate === item.jobDate)
            if (Index === -1) {
              this.$message.error({ message: this.$t('MODULE.S0001_TAB_MSG3'), showClose: true });
              return
            } else if (this.updateList[Index].attendanceDiv === '') {
              this.$message.error({ message: this.$t('MODULE.S0001_TAB_MSG3'), showClose: true });
              return
            }
          }
        }
        // 保存处理
        this.$confirm(this.$t('COMMON.MSG_SAVE'), { // 保存します。よろしいでしょうか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(() => {
          // 更新処理
          amsApi.s0001Tab1_update(param).then(res => {
            if (res.code === 202) {//更新成功
              this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) // 更新成功
              this.updateList = undefined;
              this.updateList = new Array();
              this.isEditMode = false
              this.firstEditClickFlg = true
              this.passedDateFlg = false
              this.query()
            } else if (res.code === 433) {//shift lock error
              this.$message.warning({ message: this.$t('COMMON.MSG_SHIFT_LOCK'), showClose: true })
            } else if (res.code === 311) {
              this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
            }
            // this.res_code_back(res)
          })
        }).catch(() => {
          // いいえ
        })
      }
    },
    //キャンセルイベント
    strDoSelectClean() {
      if (this.isEditMode == true) {
        if (this.updateList.length > 0) {
          this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: true
          }).then(() => {
            this.updateList = undefined;
            this.updateList = new Array();
            this.isEditMode = false
            this.firstEditClickFlg = true
            this.passedDateFlg = false
            if (document.querySelector(".calenderMode1-calendar .is-selected") !== null) {
              document.querySelector(".calenderMode1-calendar .is-selected").classList.remove('is-selected');
            }
            this.selectedDay = ''

          }).catch(() => {
            // いいえ
          })
        } else {
          this.updateList = undefined;
          this.updateList = new Array();
          this.isEditMode = false
          this.firstEditClickFlg = true
          this.passedDateFlg = false
          if (document.querySelector(".calenderMode1-calendar .is-selected") !== null) {
            document.querySelector(".calenderMode1-calendar .is-selected").classList.remove('is-selected');
          }
          this.selectedDay = ''
        }
      }

    },
    //点击后失去焦点(用于按钮还原)
    handleClick(e) {
      let target = e.target;
      target.blur();
    },
    //リストで重複データを除く
    // unique(arr) {
    //   const res = new Map();
    //   return arr.filter((arr) => !res.has(arr.selectData) && res.set(arr.selectData, 1));
    // },
    //タッチstart
    touchStart(in_date) {
      this.longPress=false
      // var thisDay = in_date.day
      // var thisDayType = in_date.type
      clearTimeout(this.loop); //再次清空定时器，防止重复注册定时器
      //编辑模式以外时进入计时器
      // if (this.isEditMode == false) {
      //   this.loop = setTimeout(() => {
      //     console.log('touchStart 1')
      //     //计时成功后再次判断是否是编辑模式
      //     if (this.isEditMode == false && this.shiftLockFlg === '0') {
      //        this.longPress=true
      //          console.log('touchStart 2')
      //     //  this.isEditMode = true
      //       return false
      //     } else {
      //       //无处理
      //     }
      //   }, 500);
      // }


     
        this.loop = setTimeout(() => {
         this.longPress=true
        }, 500);
      

    },
    //タッチend
    touchEnd(in_date) {
      clearTimeout(this.loop); //清空定时器，防止重复注册定时器
      if (this.touchmoveFlag == false) {
         if(this.isEditMode == false&&this.longPress==true&&this.shiftLockFlg === '0'){
            this.isEditMode = true            
         }
        this.longPress=false
        this.dateCellClick(in_date.day)       
      }
      this.touchmoveFlag = false;
    },
    //タッチmove
    touchMove() {
      this.touchmoveFlag = true;
    },

  },
  computed: {
    //selectedMonth->selectedMonthStr yyyymm->yyyy年mm月
    selectedMonthStr() {
      return this.selectedMonth.substring(0, 4) + '年' + this.selectedMonth.substring(4, 7) + '月'
    }
  },
};
</script>
<style>
.s0001tab1Class .cell_status_1 {
  background-color: #98c9f7;
}
.s0001tab1Class .cell_status_2 {
  background-color: #fbe5d6;
}
.s0001tab1Class .cell_status_3 {
  background-color: #e7e4e4;
}
.s0001tab1Class .is-selected {
  color: #000000;
  font-weight: bold;
}
.s0001tab1Class .el-calendar-table .el-calendar-day {
  height: 50px;
  padding: 0px;
}
.s0001tab1Class .el-calendar__body {
  padding-bottom: 10px;
  padding: 0 0 0 0;
}
/* 本月以外の日付はクリック無効 */
.s0001tab1Class .el-calendar-table td.next {
  pointer-events: none;
}
.s0001tab1Class .el-calendar-table td.prev {
  pointer-events: none;
}
/* copy paste 禁止 */
.s0001tab1Class .el-main {
  height: 100%;
  padding: 0 !important;
  overflow: hidden;
  position: relative;
}

.s0001tab1Class .el-calendar-table thead th {
  background-color: #3f50ec27;
  border: 1px solid #e2e3e4;
  padding-top: 7px;
  padding-bottom: 7px;
}
/*出勤可能時間帯专用 input输入框*/
.s0001tab1Class .card-css-input {
  width: 100%;
  padding: 0px 0px 0px 0px;
}
/*出勤可能時間帯专用 input输入框--只读*/
.s0001tab1Class .card-css-input-readonly {
  width: 100%;
  padding: 0px 0px 0px 0px;
}
/*出勤可能時間帯专用 input输入框内部--只读*/
.s0001tab1Class .card-css-input-readonly .el-input__inner{
  background-color: #e7e4e4;
}
/*备考专用 input输入框内部--只读*/
.s0001tab1Class .card-css-input-readonly .el-textarea__inner{
  background-color: #e7e4e4;
}
/* 隐藏calendar的日期头和按钮部分 */
.s0001tab1Class .el-calendar .el-calendar__header {
  display: none;
}
/* radio间距 */
.s0001tab1Class .el-radio {
  margin-right: 5px;
}
/* calenderMode2各样式调节 */
.s0001tab1Class .calenderMode2-calendar .cell {
  padding-left: 4px;
  padding-right: 4px;
}
/* calenderMode2各样式调节 */
.s0001tab1Class .calenderMode2-calendar .el-input__inner {
  padding-left: 7px;
  padding-right: 4px;
}
/* calenderMode2各样式调节 */
.s0001tab1Class .calenderMode2-calendar .el-table td,
.el-table th {
  text-align: center;
  padding: 4px 0;
}
.s0001tab1Class .opacity {
  position: absolute;
  width: 100px;
  -khtml-opacity: 0.2;
  -moz-opacity: 0.2;
  filter: alpha(opacity=20);
  filter: 'alpha(opacity=20)';
  opacity: 0.2;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=20);
  z-index: 200; /*兼容ie8及以下*/
}
/* 区分的下拉列表尺寸 */
.s0001tab1Class .el-select-dropdown__wrap {
  margin-bottom: 0px;
}
.s0001tab1Class .el-table th {
  background-color: #23b2e8;
  color: #ffffff;
}
/*safari用 去掉入力框阴影*/
.s0001tab1Class textarea {
  -webkit-appearance: none;
}
</style>


// WEBPACK FOOTER //
// src/module/page/s_0001_tab1.vue